/* Telegram Mini App bootstrap. Every step degrades to a no-op in a plain
 * browser, so `npm run dev` outside Telegram keeps working. */
import { init, miniApp, retrieveLaunchParams, viewport } from '@telegram-apps/sdk-react';

/** Matches --bg-app: the v2 monochrome canvas. Keeps Telegram's chrome flush with ours. */
const CANVAS = '#060606';

const DEV_INIT_KEY = 'nd_init_data';

export function initTelegram() {
  try {
    init();

    if (miniApp.mount.isAvailable()) {
      miniApp.mount();
      if (miniApp.setHeaderColor.isAvailable()) miniApp.setHeaderColor(CANVAS);
      if (miniApp.setBackgroundColor.isAvailable()) miniApp.setBackgroundColor(CANVAS);
    }

    if (viewport.mount.isAvailable()) {
      void viewport.mount().then(() => {
        if (viewport.expand.isAvailable()) viewport.expand();
        viewport.bindCssVars();
      });
    }
  } catch {
    /* Not inside Telegram — plain-browser development. */
  }
}

/** Raw initData for POST /api/auth. Missing outside Telegram — that is not a
 *  demo session. DEV-only query/sessionStorage is a local mint, never shipped. */
export function readTelegramInitData(): string | undefined {
  try {
    const raw = retrieveLaunchParams().initDataRaw;
    if (raw) return raw;
  } catch {
    /* launch params absent */
  }

  if (typeof window !== 'undefined') {
    const tg = (
      window as unknown as { Telegram?: { WebApp?: { initData?: string } } }
    ).Telegram?.WebApp?.initData;
    if (tg) return tg;
  }

  if (!import.meta.env.DEV || typeof window === 'undefined') return undefined;

  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get('initData');
  if (fromQuery) {
    sessionStorage.setItem(DEV_INIT_KEY, fromQuery);
    params.delete('initData');
    const search = params.toString();
    const next = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
    window.history.replaceState(null, '', next);
    return fromQuery;
  }
  return sessionStorage.getItem(DEV_INIT_KEY) ?? undefined;
}

export function clearDevInitData(): void {
  if (import.meta.env.DEV && typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(DEV_INIT_KEY);
  }
}
